<template>
  <div> 
    <!-- <section class="d-flex body-content" style="background-color: #f1f3f4">
      <h1>Lobby Template 1</h1>
    </section> -->
  <div class="page-effect">
    <div class="container-fluid border-bottom p-0 ss-reg-top pt-3">
      <div class="admin-edit-lobby-head-area d-flex justify-content-between align-items-center pl-2">
        <h3>Lobby Template 3</h3>
        <div class="d-md-flex justify-content-end page-option-sticky">
          <a
            href="#"
            class=" pt-3"
            data-toggle="modal"
            data-target="#welcomemailModalCenter"
            @click="$refs.reminderAnnounceMailPopup.getMailTemplate('ReminderMail')"

            >
            <v-icon color="#1c1d26" size="25px">mdi-arrow-right-top</v-icon> Send Mail</a
          >
          <a
            href="#"
            class=" pt-3"
            data-toggle="modal"
            data-target="#RegistrationtypeModal"
            ><v-icon color="#1c1d26" size="25px">mdi-cog-outline</v-icon>Lobby Settings</a
          >
          
          <a
            href="#"
            class=" pt-3"
            data-toggle="modal"
            data-target="#CheckoutformypeModal"
            ><v-icon color="#1c1d26" size="25px">mdi-tray-arrow-up</v-icon> Bulk Import</a
          >
        </div>
      </div>
    </div>
    <div class="d-flex body-content py-0">
      <div class="lobby-wrap position-relative">
        <img src="../assets/Images/lobby-templates/lobby3.jpg"/>
        
        <div class="blink_ffect_wrapper edit-wrap16">
          <a class="circle_blink_button" data-openeditor="left-banner" @click.stop="drawer = !drawer">
            <span>&nbsp;</span>
          </a>
        </div>
        
        <div class="blink_ffect_wrapper edit-wrap17">
          <a class="circle_blink_button" data-openeditor="left-banner" @click.stop="drawer = !drawer">
            <span>&nbsp;</span>
          </a>
        </div>
        
        
        <div class="blink_ffect_wrapper edit-wrap18">
          <a class="circle_blink_button" data-openeditor="left-banner" @click.stop="drawer = !drawer">
            <span>&nbsp;</span>
          </a>
        </div>
      </div>
      
    </div>

    
  </div>
  <v-navigation-drawer
      v-model="drawer"
      top
      fixed
      width="400"
      floating="true"
      class="p-3"
      temporary
      hide-overlay="true"
    >
      <div class="editor-drawer-head">
        <h4 class="mb-0 d-flex justify-content-start align-items-ceter"><v-icon color="#1c1d26" size="25px">mdi-chevron-left</v-icon> Editor</h4>
      </div>
      <div class="hotspots-wrapper mt-3">
        <div class="single-edit-hotspot my-3">
          <h5>On Demand Video</h5>
          <label>Add Title</label>
          <input type="text" name="" id="" value="" />
          <label>Add URL</label>
          <input type="text" name="" id="" value="https://" />
          <p class="my-2 text-center"><b>Or</b></p>
          
          <div class="lobby-upload-banner-image">
            <label>Upload Video</label>
            <div class="d-flex justify-content-between align-items-center final-button mb-4">
              <input type="file" name="" id="" value="" />
              <v-btn dark color="#1c1d26">Upload</v-btn>
            </div>
            <div class="lobby-banner-image mb-5">
              <div class="image-holder">
                <img src="../assets/Images/reg-ico/video-file.svg"/>
              </div>
              <v-btn icon><v-icon color="#1c1d26" size="25px">mdi-trash-can-outline</v-icon></v-btn>
            </div>
          </div>
          <div class="d-flex justify-content-end align-items-center final-button">
            <v-btn outlined color="#1c1d26" width="120px" class="mr-2">Cancel</v-btn>
            <v-btn dark color="#1c1d26" width="120px">Save</v-btn>
          </div>
        </div>


        <div class="single-edit-hotspot my-3">
          <h5>Speakers</h5>
          <label>Add Title</label>
          <input type="text" name="" id="" value="" />
          <label>Add URL</label>
          <input type="text" name="" id="" value="https://" />
          <div class="d-flex justify-content-end align-items-center final-button">
            <v-btn outlined color="#1c1d26" width="120px" class="mr-2">Cancel</v-btn>
            <v-btn dark color="#1c1d26" width="120px">Save</v-btn>
          </div>
        </div>

        <div class="single-edit-hotspot my-3">
          <h5>Agenda</h5>
          <label>Add Title</label>
          <input type="text" name="" id="" value="" />
          <label>Add URL</label>
          <input type="text" name="" id="" value="https://" />
          <div class="d-flex justify-content-end align-items-center final-button">
            <v-btn outlined color="#1c1d26" width="120px" class="mr-2">Cancel</v-btn>
            <v-btn dark color="#1c1d26" width="120px">Save</v-btn>
          </div>
        </div>

        <!-- <div class="single-edit-hotspot my-3">
          <h5>Network Lounge</h5>
          <label>Add Title</label>
          <input type="text" name="" id="" value="" />
          <label>Add URL</label>
          <input type="text" name="" id="" value="https://" />
          <div class="d-flex justify-content-end align-items-center final-button">
            <v-btn outlined color="#1c1d26" width="120px" class="mr-2">Cancel</v-btn>
            <v-btn dark color="#1c1d26" width="120px">Save</v-btn>
          </div>
        </div>

        <div class="single-edit-hotspot my-3">
          <h5>Speakers</h5>
          <label>Add Title</label>
          <input type="text" name="" id="" value="" />
          <label>Add URL</label>
          <input type="text" name="" id="" value="https://" />
          <div class="d-flex justify-content-end align-items-center final-button">
            <v-btn outlined color="#1c1d26" width="120px" class="mr-2">Cancel</v-btn>
            <v-btn dark color="#1c1d26" width="120px">Save</v-btn>
          </div>
        </div>
        <div class="single-edit-hotspot my-3">
          <h5>Data Storage</h5>
          <label>Add Title</label>
          <input type="text" name="" id="" value="" />
          <label>Add URL</label>
          <input type="text" name="" id="" value="https://" />
          <div class="d-flex justify-content-end align-items-center final-button">
            <v-btn outlined color="#1c1d26" width="120px" class="mr-2">Cancel</v-btn>
            <v-btn dark color="#1c1d26" width="120px">Save</v-btn>
          </div>
        </div>

        <div class="single-edit-hotspot my-3">
          <h5>Exhibitors</h5>
          <label>Add Title</label>
          <input type="text" name="" id="" value="" />
          <label>Add URL</label>
          <input type="text" name="" id="" value="https://" />
          <div class="d-flex justify-content-end align-items-center final-button">
            <v-btn outlined color="#1c1d26" width="120px" class="mr-2">Cancel</v-btn>
            <v-btn dark color="#1c1d26" width="120px">Save</v-btn>
          </div>
        </div>

        <div class="single-edit-hotspot my-3">
          <h5>Help Desc</h5>
          <label>Add Title</label>
          <input type="text" name="" id="" value="" />
          <label>Add URL</label>
          <input type="text" name="" id="" value="https://" />
          <div class="d-flex justify-content-end align-items-center final-button">
            <v-btn outlined color="#1c1d26" width="120px" class="mr-2">Cancel</v-btn>
            <v-btn dark color="#1c1d26" width="120px">Save</v-btn>
          </div>
        </div> -->
      </div>
    </v-navigation-drawer>
  </div>
</template>
<script>
// import db from "../components/firebaseInit";
// import APIs from "@/components/APIInit";
// import router from "../router";
// import jQuery from "jquery";
// let $ = jQuery;
// var self;
// import Vue from "vue";
// import VueMoment from "vue-moment";
// import moment from "moment-timezone";
// import axios from "axios";
// import { bus } from "@/main";
// Vue.use(VueMoment, {
//   moment,
// });

export default {
  data() {
    return {
      drawer: false,
      group: null,
    };
  },
  computed: {
  },
  watch: {
     group () {
        this.drawer = false
      },
  },
  created() {
  },
  mounted() {
  },
  methods: {
  },
};
</script>